import { render, staticRenderFns } from "./add-check.html?vue&type=template&id=2808263e&scoped=true&external"
import script from "./add-check.js?vue&type=script&lang=js&external"
export * from "./add-check.js?vue&type=script&lang=js&external"
import style0 from "./add-check.scss?vue&type=style&index=0&id=2808263e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2808263e",
  null
  
)

export default component.exports